export default __webpack_public_path__ + "static/media/rectangle5@3x.6580e6a3.png";